var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.24073L9.01145 4.25205C6.52207 4.28055 4.48031 4.5503 3.0831 5.28511C2.4069 5.64074 1.90307 6.09478 1.56127 6.67316C1.21812 7.25385 1 8.02482 1 9.07267C1 10.1172 1.47584 11.2058 2.14967 12.0623C1.87238 10.3924 2.13168 8.99355 3.21452 7.99611C3.86682 7.39527 4.72522 7.04077 5.67336 6.82636C6.62527 6.6111 7.74252 6.52063 8.98562 6.50275L10 6.48815V9.70377L14.8676 5.5L10 1.29665V4.24073ZM15.7403 6.06761L10.2402 10.8176C9.75938 11.2329 9 10.8969 9 10.25V7.50264C8.65239 7.50764 8.31897 7.51847 8 7.53595C3.87201 7.76207 2.1662 9.10046 3.48156 13.3071C3.63888 13.8101 3.03081 14.1996 2.60416 13.8893C1.23691 12.8948 0 10.9927 0 9.07267C0 4.31562 3.98034 3.30959 9 3.25212V0.750465C9 0.104591 9.75878 -0.23294 10.2402 0.182841L15.7403 4.93237C16.0868 5.23158 16.0863 5.7688 15.7403 6.06761Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.98a12e6c73b4e28753eff30a058fee07.svg";
export { ForwardRef as ReactComponent };